import React from 'react'
import PropTypes from 'prop-types'
import { BaseInput } from './BaseInput'
import { FormControlWrapper } from '../../FormControlWrapper'
import { ErrorMessage } from '../ErrorMessage'
import { toTitleCase } from '../../../services/handlers'

export const Input = ({
  id,
  placeholder,
  errorMessage,
  error,
  onChange,
  onBlur,
  onFocus,
  name,
  value,
  type,
  style,
  pattern,
  titleCase,
  tabIndex,
}) => {
  const onInput = (e) => {
    if (titleCase) {
      e.target.value = toTitleCase('' + e.target.value)
    }
  }

  return (
    <FormControlWrapper>
      {error && errorMessage && (
        <ErrorMessage id={`${name}Error`}>{errorMessage}</ErrorMessage>
      )}
      <BaseInput
        placeholder={placeholder}
        error={error}
        onInput={onInput}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        name={name}
        id={id}
        value={value}
        type={type}
        style={style}
        autoComplete='on'
        autoCorrect='off'
        pattern={pattern}
        tabIndex={tabIndex}
      />
    </FormControlWrapper>
  )
}

Input.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
}
